export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4677.477f0a7a.jpg";